import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { ApplicationMessage } from './models/application-message';
import { MessageType } from './models/enum/message-type';

@Injectable({ providedIn: 'root' })
export class CustomMessageService {
  private _messages: { [index: string]: ToastMessageOptions[] };
  private applicationMessages: ApplicationMessage[];

  public messages(sourceId: string = 'global') {
    return this.getMessages(sourceId);
  }

  public pushMessage(
    message: ApplicationMessage,
    clearExisting: boolean = true
  ) {
    message.sourceId = message.sourceId || 'global';
    if (clearExisting) {
      this.clearAll(message.sourceId);
    }
    this.applicationMessages.push(message);
    this.syncMessages();
  }

  public clearAll(sourceId: string = 'global') {
    this.applicationMessages = this.applicationMessages.filter(
      (m) => m.sourceId != sourceId
    );
    this.syncMessages();
  }

  private syncMessages() {
    this._messages = {};
    this.applicationMessages.forEach((m) => {
      if (this._messages[m.sourceId] == null) {
        this._messages[m.sourceId] = [];
      }
      this._messages[m.sourceId].push(this.transform(m));
    });

    for (let key in this._messages) {
      this.messageService.clear(key);
      this.messageService.addAll(this._messages[key]);
    }
  }

  private getMessages(sourceId: string = 'global'): ToastMessageOptions[] {
    return this._messages[sourceId];
  }

  private transform(sourceMessage: ApplicationMessage): ToastMessageOptions {
    return {
      key: sourceMessage.sourceId,
      severity: this.severityMap[sourceMessage.type],
      summary: sourceMessage.summary,
      detail: sourceMessage.detail,
    };
  }

  private severityMap: any;

  constructor(private messageService: MessageService) {
    this.severityMap = {};

    this.severityMap[MessageType.Error] = 'error';
    this.severityMap[MessageType.Warning] = 'warn';
    this.severityMap[MessageType.Info] = 'info';
    this.severityMap[MessageType.Success] = 'success';

    this._messages = {};
    this._messages['global'] = [];
    this.applicationMessages = [];

    //TODO rest message types
  }
}
